import ClientsXGroup from "./ClientsXGroup";

export default ClientsXGroup;
